"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWeekend = void 0;
const isWeekend = (_option, dayjsClass) => {
    dayjsClass.prototype.isWeekend = function () {
        return [6, 7].includes(this.isoWeekday());
    };
};
exports.isWeekend = isWeekend;
